import { addBreadcrumb } from '@sentry/react';
/**
 * Шаг пути пользователя. Уходит breadcrumb'ом вместе с любым следующим событием,
 * так что открыв событие пользователя, видно, что с ним происходило до него.
 *
 * @param {string} message - Что произошло.
 * @param {Object} data - Детали.
 * @param {SeverityLevel} level - Уровень.
 * @returns {void}
 */
export const addJourneyStep = (message, data, level = 'info') => {
    addBreadcrumb({
        category: 'journey',
        message,
        data,
        level
    });
};
// болтливые debug-логи, которые вытесняют полезные breadcrumbs
const NOISY_CONSOLE_BREADCRUMBS = [
    /Channel JSON-formatted message/,
    /trackLogs - /,
    /Scheduling next WebSocket keep-alive/,
    /Track state for participant/
];
/**
 * Отсекает шумные breadcrumbs из консоли.
 *
 * @param {string} category - Категория breadcrumb.
 * @param {string} message - Текст.
 * @returns {boolean}
 */
export const isNoisyBreadcrumb = (category, message) => category === 'console' && Boolean(message) && NOISY_CONSOLE_BREADCRUMBS.some(re => re.test(message ?? ''));
